import { z } from 'zod';

// Vite bakes VITE_* vars at build time. When a build arg is left unset, the
// Dockerfile emits an empty string rather than dropping the var — so treat ''
// as "not provided" before validating, otherwise optional URLs reject ''.
const emptyToUndefined = (v: unknown) => (v === '' ? undefined : v);

const envSchema = z.object({
  VITE_API_BASE_URL: z.preprocess(
    emptyToUndefined,
    z.string().url().default('http://localhost:3000'),
  ),
  VITE_SUPABASE_URL: z.preprocess(emptyToUndefined, z.string().url().optional()),
  VITE_SUPABASE_ANON_KEY: z.preprocess(emptyToUndefined, z.string().optional()),
});

export const env = envSchema.parse(import.meta.env);
